import { render, staticRenderFns } from "./ClientsSideviewGeneralTab.vue?vue&type=template&id=55582419&scoped=true&class=fill-height&"
import script from "./ClientsSideviewGeneralTab.vue?vue&type=script&lang=ts&"
export * from "./ClientsSideviewGeneralTab.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsSideviewGeneralTab.vue?vue&type=style&index=0&id=55582419&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55582419",
  null
  
)

export default component.exports